/** Mga card ng Service Desk sa dashboard at sa billing overview (RPT-002, PLN-005, SD-S1-53). */
export const serviceCards = {
  dashboard: {
    title: "Service Desk",
    subtitle: "Kung nasaan ang team ngayon",
    open: "Mga bukas na ticket",
    openHint: "Bago, bukas, naghihintay at naka-hold",
    breaching: "Malapit nang malabag",
    breachingHint: "Due sa loob ng isang oras o huli na",
    csat: "CSAT, nakaraang 30 araw",
    csatNone: "Wala pang rating",
    csatHint_other: "{{count}} sagot",
    csatHint_one: "{{count}} sagot",
    openTickets: "Mga bukas na ticket",
    openReports: "Mga Ulat sa Serbisyo",
    loadError: "Hindi namin ma-load ang mga numero ng Service Desk.",
    retry: "Subukan ulit",
  },
  billing: {
    title: "Paggamit ng Service Desk",
    subtitle: "Mga ticket, storage, connector, catalogue, order, kagamitan at staff AI",
    tickets: "Mga ticket ngayong buwan",
    ticketsHint: "Patas na paggamit: walang kliyenteng tatanggihan ng ticket.",
    storage: "Storage ng attachment",
    storageHint: "Mga larawan, dokumento at lagda sa mga ticket.",
    connectors: "Mga connector",
    connectorsHint: "Mga sistemang konektado ang iyong mga order at catalogue.",
    catalogue: "Mga item sa catalogue",
    catalogueHint: "Mga aktibong produkto mula sa iyong purchasing system.",
    orders: "Mga order ngayong buwan",
    ordersHint: "Mga order na kinumpirma ng iyong mga kliyente.",
    assets: "Kagamitang ginagamit",
    assetsHint: "Mga nakarehistrong unit na hindi pa retiro.",
    fieldSeats: "Mga field seat",
    fieldSeatsHint: "Mga miyembrong Field engineer lang ang tungkulin.",
    staffAi: "Mga staff AI credit ngayong buwan",
    staffAiHint: "Mga buod, iminumungkahing sagot at triage.",
    unlimited: "Walang limitasyon",
    noLimit: "walang limitasyon",
    of: "/ {{value}}",
    mb: "{{value}} MB",
    gb: "{{value}} GB",
    readOnly: "Hindi na kasama sa plano mo ang Service Desk. Mananatili itong read-only hanggang {{date}}.",
    readOnlyNoDate: "Hindi na kasama sa plano mo ang Service Desk, kaya read-only na ito.",
    closed: "Hindi na kasama sa plano mo ang Service Desk.",
    reports: "Mga Ulat sa Serbisyo",
    loadError: "Hindi namin ma-load ang paggamit ng Service Desk.",
    retry: "Subukan ulit",
  },
} as const;
